export const ParkingType = [
    { value: "Todos", name: "Todos" },
    { value: "rotativo", name: "Rotativo" },
    { value: "convenio", name: "Convênios" },
];